import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiStatus } from '../utils/constants';
import api from '../utils/api';

export const allCappers = createAsyncThunk('users/allCappers', async (_, thunkAPI) => {
  try {
    const response = await api.get('/user/allCappers');
    return response;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const cappersSlice = createSlice({
  name: 'cappers',
  initialState: {
    cappers: [],
    status: ApiStatus.idle,
    errorMessage: ''
  },
  reducers: {},
  extraReducers: {
    [allCappers.fulfilled]: (state, { payload }) => {
      state.cappers = payload.cappers;
      state.status = ApiStatus.success;
      return state;
    },
    [allCappers.rejected]: (state, props) => {
      state.errorMessage = props.payload.error;
      state.status = ApiStatus.failed;
      state.isAuthenticated = false;
    },
    [allCappers.pending]: (state) => {
      state.status = ApiStatus.loading;
    }
  }
});

export const cappersSelector = (state) => state.cappers;
